import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonItemGroup } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-item-group',
  standalone: true,
  imports: [CommonModule, IonItemGroup],
  templateUrl: './item-group.component.html',
  styleUrl: './item-group.component.css',
})
export class ItemGroupComponent {
  @Input() groupClass?: string;

  get hostClassString(): string {
    const parts: string[] = ['crowdctrl-item-group'];
    const extra = this.groupClass?.trim();
    if (extra) {
      parts.push(extra);
    }
    return parts.join(' ');
  }
}
